let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ilkdv")).then(() => parcelRequire('kaifB'));